import React, { useContext, useCallback } from 'react';
import {} from 'react-icons/fi';
import { LPText, ContentWrapper } from '../../../styles';
import { RSVPContext } from '../../context';
import StickyFooter from '../../../../components/StickyFooter';

import RadioBtn from '../../../../components/RadioBtn';

const StepQuestions = () => {
  const {
    contextData: {
      questions,
      questionsData,
      isQuestionsFormValid,
      setQuestionAnswer,
      validationQuestionErrors,

      eventItemData,
      saveData,
      goToNextStep,

      mutationLoading,
    },
  } = useContext(RSVPContext);

  const {
    getVpn: {
      availableEvents,
    },
  } = eventItemData;

  const event = availableEvents[0];

  const {
    representationalMetadataList,
  } = event;

  const handleChange = useCallback(
    (name, value) => {
      setQuestionAnswer(name, value);
    },
    [setQuestionAnswer],
  );

  const getErrorMessages = (name) => {
    const messages = [];
    validationQuestionErrors.forEach((e) => {
      if (e.path === name && questionsData[name]) {
        messages.push(e.message);
      }
    });
    return messages;
  };

  const pageData = {
    instructions: '',
    btnLabel: '',
  };

  representationalMetadataList.forEach(({
    destination,
    content,
    type,
  }) => {
    if (destination === 'capture_page') {
      switch (type) {
        case 'BTN_LABEL':
          pageData.btnLabel = content;
          break;
        case 'INSTRUCTIONS':
          pageData.instructions = content;
          break;
        default:
          break;
      }
    }
  });

  let { btnLabel } = pageData;
  btnLabel = mutationLoading ? 'Submitting...' : btnLabel;

  return (
    <>
      <ContentWrapper>
        <LPText mb2>
          Please complete the COVID-19 self assessment questionnaire 😷🙏.
        </LPText>

        {questions.map(({ label, options, name }) => (
          <>
            <RadioBtn
              key={name}
              label={label}
              name={name}
              value={questionsData[name]}
              items={options}
              onChange={(e) => handleChange(name, e.target.value)}
              errors={getErrorMessages(name)}
            />
          </>
        ))}
      </ContentWrapper>

      <StickyFooter
        disabled={!isQuestionsFormValid}
        title={btnLabel}
        handleOnclick={() => saveData({ onSuccess: goToNextStep })}
      />
    </>
  );
};

StepQuestions.propTypes = {};

export default StepQuestions;
